import { useEffect } from "react";
import { subscribeBrowserVisibilityRefetch } from "@Front/Utils/browserVisibilityRefetchSubscription";

export type UseCloseOpenableOnPageShowOptions = {
	/**
	 * When false, only BFCache restore (`pageshow` + persisted) closes.
	 * Use for ConfirmModal: a native file picker fires `visibilitychange`
	 * and must not unmount the input or reset pending files.
	 */
	closeOnTabVisible?: boolean;
};

/**
 * Closes an openable on BFCache restore (`pageshow` + `event.persisted`).
 * By default also closes when the tab becomes visible (`visibilitychange`) —
 * Header / Menu only. ConfirmModal must pass `closeOnTabVisible: false`.
 */
export function useCloseOpenableOnPageShow(
	isOpen: boolean,
	close: () => void,
	options?: UseCloseOpenableOnPageShowOptions,
): void {
	const closeOnTabVisible = options?.closeOnTabVisible ?? true;
	useEffect(() => {
		if (!isOpen) {
			return undefined;
		}
		return subscribeBrowserVisibilityRefetch(close, {
			includeVisibilityChange: closeOnTabVisible,
		});
	}, [close, closeOnTabVisible, isOpen]);
}
